<script setup>
import { ref } from "vue";
import { RouterLink, useRoute } from "vue-router";

const isNavOpen = ref(true);
const route = useRoute();

function toggleNav() {
    isNavOpen.value = !isNavOpen.value;
}

const navItems = [
    // { name: "Dashboard", path: "/admin/dashboard", icon: "📊" },
    { name: "Therapists", path: "/admin/therapists", icon: "👥" },
    { name: "Mass Actions", path: "/admin/mass_actions", icon: "🔨" },
    { name: "Sync Health", path: "/admin/sync_health", icon: "🔄" }
    // { name: 'Settings', path: '/admin/settings', icon: '⚙️' },
];

const bottomNavItems = [
    { name: "Landing Page", path: "/user", icon: "👤" },
    { name: "Logout", path: "/logout", icon: "🚪" },
];
</script>

<template>
  <div class="min-h-screen flex">
    <!-- Navigation -->
    <nav
      class="bg-[rgb(62,68,78)] shadow-lg transition-all duration-300 flex flex-col"
      :class="isNavOpen ? 'w-64' : 'w-14'"
    >
      <!-- Logo/Home -->
      <div class="border-b relative flex justify-between items-center h-12 bg-gray-300">
        <RouterLink v-if="isNavOpen" to="/admin" class="flex items-center justify-center w-full space-x-2">
          <img src="@/assets/logo_full.svg" class="h-12 text-white" alt="Logo" />
        </RouterLink>
        <button @click="toggleNav" :class="isNavOpen ? 'absolute right-0 w-12' : 'w-full'" class="text-gray-500 h-12 hover:text-gray-700 px-2">
          {{ isNavOpen ? '◀' : '▶' }}
        </button>
      </div>

      <!-- Nav Items -->
      <div class="h-full flex flex-col justify-between">
        <div>
          <RouterLink
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="flex items-center px-4 py-2 hover:bg-[rgb(82,88,98)]"
            :class="route.path === item.path ? 'bg-[rgb(82,88,98)]' : ''"
          >
            <span class="text-xl">{{ item.icon }}</span>
            <span v-if="isNavOpen" class="ml-3 uppercase font-mono font-semibold text-lg text-gray-200">{{ item.name }}</span>
          </RouterLink>
        </div>
        <div>
          <RouterLink
            v-for="item in bottomNavItems"
            :key="item.path"
            :to="item.path"
            class="flex items-center px-4 py-2 hover:bg-[rgb(82,88,98)]"
          >
            <span class="text-xl">{{ item.icon }}</span>
            <span v-if="isNavOpen" class="ml-3 uppercase font-mono font-semibold text-lg text-gray-200">{{ item.name }}</span>
          </RouterLink>
        </div>
      </div>
    </nav>

    <!-- Main Content -->
    <div class="flex-1">
      <!-- Header -->
      <header class="bg-[rgb(0,201,208)] shadow-md">
        <div class="max-w-7xl mx-auto px-4 py-4">
          <h1 class="text-2xl font-bold text-white">
            {{ route.meta.title || 'Admin Portal' }}
          </h1>
        </div>
      </header>

      <!-- Page Content -->
      <main class="max-w-7xl mx-auto px-4 py-6">
        <RouterView />
      </main>
    </div>
  </div>
</template>
